import React, { useState } from 'react';
import Image from '../images/solar-energy.webp';
const SolarPanelTypes = () => {
  const [activeTab, setActiveTab] = useState('monocrystalline');

  const panels = {
    monocrystalline: {
      title: "Monocrystalline Solar Panels",
      efficiency: "20-22%",
      lifespan: "25-30 years",
      spaceEfficiency: "High",
      appearance: "Black cells with uniform appearance",
      cost: "Higher initial cost, better long-term value",
      bestFor: "Limited roof space, premium installations",
      image: Image
    },
    polycrystalline: {
      title: "Polycrystalline Solar Panels",
      efficiency: "15-17%",
      lifespan: "23-27 years",
      spaceEfficiency: "Medium",
      appearance: "Blue cells with multi-faceted appearance",
      cost: "More affordable option",
      bestFor: "Budget-conscious projects with adequate space",
      image: Image
    },
    thinFilm: {
      title: "Thin-Film Solar Panels",
      efficiency: "10-13%",
      lifespan: "15-20 years",
      spaceEfficiency: "Low",
      appearance: "Solid black, sleek and flexible",
      cost: "Lowest cost per panel",
      bestFor: "Large commercial installations, curved surfaces",
      image: Image
    }
  };

  const renderTabContent = (type) => {
    const panel = panels[type];
    
    return (
      <div className="grid lg:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-8 ">
        <div>
          <h3 className="text-2xl font-bold mb-4">{panel.title}</h3>
          <div className="space-y-3">
            <div className="flex">
              <div className="font-semibold w-40">Efficiency:</div>
              <div>{panel.efficiency}</div>
            </div>
            <div className="flex">
              <div className="font-semibold w-40">Lifespan:</div>
              <div>{panel.lifespan}</div>
            </div>
            <div className="flex">
              <div className="font-semibold w-40">Space Efficiency:</div>
              <div>{panel.spaceEfficiency}</div>
            </div>
            <div className="flex">
              <div className="font-semibold w-40">Appearance:</div>
              <div>{panel.appearance}</div>
            </div>
            <div className="flex">
              <div className="font-semibold w-40">Cost:</div>
              <div>{panel.cost}</div>
            </div>
            <div className="flex">
              <div className="font-semibold w-40">Best For:</div>
              <div>{panel.bestFor}</div>
            </div>
          </div>
          <button className="mt-6 px-6 py-3 bg-primary text-white rounded-md font-medium hover:bg-primaryHover transition-colors">
            Learn More
          </button>
        </div>
        <div>
          <img src={panel.image} alt={panel.title} className="rounded-lg shadow-lg w-full" />
        </div>
      </div>
    );
  };

  return (
    <div className="bg-gray-50 p-8 rounded-lg w-full max-w-8xl mx-auto shadow-md">
      <h2 className="text-3xl font-bold text-center mb-8">Solar Panel Technologies</h2>
      
      <div className="flex flex-wrap mb-8 border-b border-gray-300 items-center justify-center">
        {Object.keys(panels).map((type) => (
          <button
            key={type}
            className={`px-6 py-3 font-medium mr-4 mb-2 border-b-2 transition-colors ${
              activeTab === type
                ? 'border-primary text-primary'
                : 'border-transparent text-gray-600 hover:text-primary'
            }`}
            onClick={() => setActiveTab(type)}
          >
            {panels[type].title}
          </button>
        ))}
      </div>
      
      <div className="tab-content py-4">
        {renderTabContent(activeTab)}
      </div>
    </div>
  );
};

export default SolarPanelTypes;